import styled from "@emotion/styled";

import { isTestingMode } from "../../../../Testing";

export const GroupButtonContainer = styled("span")({
    marginLeft: -1,
});

interface RootProps {
    group?: boolean;
    width?: number | string;
}

export const Root = styled.span<RootProps>(
    props => ({
        width: props.width,
    }),
    props =>
        props.group && {
            whiteSpace: "nowrap",
            display: "inline-flex",
            flexWrap: "nowrap",

            "> label:nth-of-type(1)": {
                // если в контрол прийдет width, то он просто перебьет этот стиль
                width: "100%",
                flexGrow: 1,
                flexShrink: 1,
            },

            "> span:nth-of-type(2)": {
                flexGrow: 0,
                flexShrink: 0,
            },
        },
    props =>
        isTestingMode() && {
            input: {
                color: "transparent",
                textShadow: `0 0 0 ${props.theme.candy.valueControls.disabledCursorTextShadowColor}`,

                ":focus": {
                    outline: "none",
                },
            },
        }
);
